export default "__VITE_ASSET__19c7d0d3__"